<template>
  <div class="modal-wrapper" :class="{
    'modal-fade-out': opened === false,
    'modal-fade-in': opened
  }">
    <div class="modal-outside" ref="modalOutside" :class="{
      'align-items-start': alignItemsStart
    }" :style="{ padding: `${paddingModalOutside}px` }">
      <div class="modal" ref="modal">
        <div class="modal-title" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">
          {{ title }}
          <img src="../assets/close-icon-big.png" alt="" class="close-default-modal" @click.prevent="closeModal" />
        </div>
        <div class="modal-body" v-html="body"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbotColors: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      opened: false,
      alignItemsStart: false,
      paddingModalOutside: 20,
      title: '',
      body: ''
    }
  },
  methods: {
    openModal () {
      this.opened = true;
      this.positionModal();
    },
    closeModal () {
      this.opened = false;
    },
    positionModal () {
      setTimeout(() => {
        const modalOutsideOffsetHeight = this.$refs.modalOutside.offsetHeight;
        const modalOffsetHeight = this.$refs.modal.offsetHeight + (this.paddingModalOutside * 2);

        this.alignItemsStart = modalOutsideOffsetHeight < modalOffsetHeight;
      }, 300)
    }
  },
  mounted () {
    window.EventBus.$on('OPEN_DEFAULT_MODAL', data => {
      this.title = data.title;
      this.body = data.body;
      this.openModal();
    });

    window.addEventListener('resize', () => {
      setTimeout(this.positionModal, 300)
    });
  }
}
</script>

<style lang="scss" scoped>
  .modal-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    border-radius: 10px;
    overflow: hidden;

    &.modal-fade-out {
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s linear 150ms, opacity 150ms;
    }
    &.modal-fade-in {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 150ms;
    }
  }

  .modal-outside {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    box-sizing: border-box;

    &.align-items-start {
      align-items: start;
    }
  }

  .modal {
    width: 100%;
    max-width: 550px;
    height: auto;
    border-radius: 5px;
    box-shadow: 0 20px 60px -2px rgba(0,0,0,.3);

    .modal-title {
      height: 50px;
      padding: 0 15px;
      border-bottom: 1px solid #ccc;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .close-default-modal {
        width: 17px;
        cursor: pointer;
      }
    }
    .modal-body {
      padding: 15px;
      text-align: center;
      background: white;
    }
  }
</style>
